// resetsenhacv.jsx
// autor: WdePaula
// última atualização: 17/9/24w | 15h34 | removido linhas comentadas




import { useState} from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { encryptPass } from '../../Services/cryptosenha';
import Swal from 'sweetalert2';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner

import "./resetsenhacv.css";

const API_URL = process.env.REACT_APP_API_URL;
const BA_USERNAME = process.env.REACT_APP_BA_USERNAME;
// const BA_PASSWORD = encryptPass(process.env.REACT_APP_BA_PASSWORD); // substituída a linha acima por esta 22/7/24w

function ResetSenhaCV() {
    var ano = new Date().getFullYear();

    const location = useLocation();
    const navigate = useNavigate();
    // const { email, validationCode } = location.state || {}; // Get email from state passed during navigation
    const { email, validationCode, colaborador } = location.state || {}; // Get email from state passed during navigation
    const [cv, setCv] = useState(validationCode);

    const [codigo, setCodigo] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmaSenha, setConfirmaSenha] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false); // loading na tela

    async function handleSubmit() {
        if (!codigo || !novaSenha || !confirmaSenha) {
            setMensagem('Todos os campos são obrigatórios.');

            setTimeout(() => {
                setMensagem('');
            }, 7000);
            return;
        }

        if (novaSenha !== confirmaSenha) {
            setMensagem('A "nova senha" e a "confirmação da nova senha" devem ser idênticas.');

            setTimeout(() => {
                setMensagem('');
            }, 7000);
            return;
        }

        if (codigo !== cv) {
            setMensagem('Código inválido. Digite novamente ou solicite um novo código.');

            setTimeout(() => {
                setMensagem('');
            }, 7000);
            return;
        }

        // alert('colaborador ', colaborador);
        // console.log('colaborador :', colaborador);

        // const authString = btoa(`${BA_USERNAME}:${BA_PASSWORD}`); // retirei do hardcoded pela linha abaixo 25/9/25w8h00
        const authString = btoa(`${BA_USERNAME}:${encryptPass(process.env.REACT_APP_BA_PASSWORD)}`);
        
        let url;
        if (colaborador === 1) {
            url = new URL(`${API_URL}/usuario/ColaboradorAlteraSenha`);
        } else {
            url = new URL(`${API_URL}/usuario/alteraSenha`);
        }

        // const url = `${API_URL}/usuario/alteraSenha`;
        // const url = `${API_URL}/usuario/alteraSenhaWeb`; // substituída pela linha acima, pois não precisa do token JWT 25/9/25w13h41 - DeepSeek
        
        setLoading(true);
        
        try {
             // ADICIONE ESTES LOGS PARA DEBUG
            // console.log('=== TENTANDO ALTERAR SENHA ===');
            // console.log('Email:', email);
            // console.log('Código digitado:', codigo);
            // console.log('Código esperado:', cv);

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${authString}`
                    // TENTE ADICIONAR ESTES HEADERS (um de cada vez para testar)
                    // 'Token': codigo,
                    // 'X-Auth-Token': codigo,
                    // 'Authorization-Token': codigo
                },
                body: JSON.stringify({
                    email: email,
                    senha: encryptPass(novaSenha) // substituímos a linha abaixo 22/7/24w
                })
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.retorno);
            }

            setLoading(false);

            setMensagem('Senha alterada com sucesso!');
            Swal.fire({
                icon: "success",
                title: "Sucesso!",
                text: "Senha alterada com sucesso!"
              }).then (()=> navigate('/app/login'));

        } catch (error) {
            // Trate o erro
            setLoading(false);

            setMensagem(error.message);
            setTimeout(() => {
                setMensagem('');
            }, 7000);
        }
    }

    async function handleResendCode() {
        // const authString = btoa(`${BA_USERNAME}:${BA_PASSWORD}`);
        const authString = btoa(`${BA_USERNAME}:${encryptPass(process.env.REACT_APP_BA_PASSWORD)}`);
        const url = new URL(`${API_URL}/usuario/validaEmail`);
        const validationCode = generateValidationCode();
        
        url.search = new URLSearchParams({
            email: email,
            codigo: validationCode
        }).toString();
        
        setLoading(true);

        try {
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${authString}`
                }
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.retorno);
            }

            setCv(validationCode);
            setLoading(false);
            setMensagem('Novo Código de Validação enviado para seu email.');
            setTimeout(() => {
                setMensagem('');
            }, 10000);

        } catch (error) {
            // Trate o erro
            setMensagem(error.message);
        } finally {
            setLoading(false);
        }
    }

    function generateValidationCode() {
        return Math.floor(100000 + Math.random() * 900000).toString();
    }

    function handleCancel() {
        navigate('/app/login');
    }



    return (
        <section id="resetsenha-cv">
            <div className="container login-container">
                <div className="row">
                    <div className="col-md-6 login-form-1">
                        <h3>Alterar Senha</h3>

                        {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                        )}
                        <div className={`row ${loading ? 'd-none' : ''}`}></div>

                        <form action="">
                        <div className="form-group mb-3">
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Digite o Código de verificação recebido (*)"
                                value={codigo}
                                onChange={(e) => setCodigo(e.target.value)}
                            />
                        </div>
                        <div className="form-group mb-3">
                            <input
                                type="password"
                                className="form-control"
                                placeholder="Nova Senha (*)"
                                value={novaSenha}
                                onChange={(e) => setNovaSenha(e.target.value)}
                            />
                        </div>
                        <div className="form-group mb-3">
                            <input
                                type="password"
                                className="form-control"
                                placeholder="Confirma Nova Senha (*)"
                                value={confirmaSenha}
                                onChange={(e) => setConfirmaSenha(e.target.value)}
                            />
                        </div>
                        <div className="form-group mb-4">
                            <input
                                type="button"
                                className="btnSubmit"
                                value="Alterar Senha"
                                onClick={handleSubmit}
                            />
                            {mensagem.length > 0 && <div className="alert alert-danger mt-2" role="alert">{mensagem}</div>}
                        </div>
                        </form>
                        <p>
                            Não recebeu o código? 
                            <button onClick={handleResendCode} className="btn btn-link">Reenviar Código</button>
                        </p>
                        <button onClick={handleCancel} className="btn btn-secondary mt-2">Cancelar</button>
                    </div>
                </div>
                <p className="text-sm">(*) campos obrigatórios.</p>
                <div className="textoRodape" >
                    <Link to="/app/novaconta">Não tenho conta. Toque para criar uma agora.</Link>
                    <br /><br />
                    <p > Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
                </div>

            </div>
        </section>
    );
}

export default ResetSenhaCV;